module.exports = __webpack_public_path__ + "static/media/default.2d283985.png";